// extracted by mini-css-extract-plugin
export default {"Options":"RemoveRevisionQuestionModal_Options__-5zi-"};